import { render, staticRenderFns } from "./MsSplitButton.vue?vue&type=template&id=1df3723f&scoped=true"
import script from "./MsSplitButton.vue?vue&type=script&lang=js"
export * from "./MsSplitButton.vue?vue&type=script&lang=js"
import style0 from "./MsSplitButton.vue?vue&type=style&index=0&id=1df3723f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3723f",
  null
  
)

export default component.exports